import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ItemApi } from 'appTypes/items'
import { ProductCardHorizontal } from 'components/ui/Card/ProductCardHorizontal'
import { List } from 'components/ui/List'
import { useTranslation } from 'react-i18next'

type Props = {
  product: ItemApi
  isBundle: boolean
}

const AccordionContent = ({ product, isBundle }: Props): JSX.Element => {
  const { t } = useTranslation(['common'])
  const singleProduct = product.products[0]

  return isBundle ? (
    <>
      {/* <PricingList data={product.pricing} /> */}
      {product.complementaryItems && (
        <>
          <Text marginY="12px" fontSize="xs">
            {t('accessories')}
          </Text>
          {product.complementaryItems.map((item, index) => (
            <Box key={index} marginBottom="20px" className="gtm-complementary-item-wrapper">
              <ProductCardHorizontal product={item.products[0]} isDark={true} price={item.price} />
            </Box>
          ))}
        </>
      )}
    </>
  ) : (
    <>
      {singleProduct.technicalDetails && singleProduct.technicalDetails.length >= 1 && (
        <List data={singleProduct.technicalDetails} title={t('technicalInfo')} />
      )}
      {/* <PricingList data={product.pricing} /> */}
      {product.complementaryItems && (
        <>
          <Text marginY="12px" fontSize="xs">
            {t('accessories')}
          </Text>
          {product.complementaryItems.map((item, index) => (
            <Flex
              key={index}
              marginBottom="20px"
              justifyContent="space-between"
              width="100%"
              className="gtm-complementary-item-wrapper"
            >
              <ProductCardHorizontal product={item.products[0]} isDark={true} price={item.price} />
            </Flex>
          ))}
        </>
      )}{' '}
    </>
  )
}

export default AccordionContent
